export default function deleteInfantFromTotalChildren(totalChildren, ages, change) {
  const isInfant = age => age <= ages.infant.age;
  const firstInfantIndex = totalChildren.findIndex(isInfant);
  const totalChildrenCopy = [...totalChildren];

  if (firstInfantIndex >= 0) {
    totalChildrenCopy.splice(firstInfantIndex, 1);
  }

  change('totalChildren', totalChildrenCopy);
}
